module.exports = __webpack_public_path__ + "static/img/dangan.25f7b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dangan.png
// module id = 5TJ+
// module chunks = 1